// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@synd/XDL/Utilities/mergeWithCss";
import React, { useState } from "react";

interface OwnProps {
    leftTitle?: string;
    rightTitles?: string[];
    extendedStyles?: LinesHeaderStyles;
    includeActions?: boolean;
    showMdScreenBorder?: boolean;
}

export interface LinesHeaderStyles {
    wrapper?: InjectableCss;
    itemDescription?: InjectableCss;
    rightSection?: InjectableCss;
    qty?: InjectableCss;
    priceUnit?: InjectableCss;
    cases?: InjectableCss;
    total?: InjectableCss;
    actions?: InjectableCss;
    mdScreenBorder?: InjectableCss;
}

export const linesHeaderStyles: LinesHeaderStyles = {};

const LinesHeader = ({
    leftTitle,
    rightTitles,
    extendedStyles,
    includeActions = false,
    showMdScreenBorder = true,
}: OwnProps) => {
    const [styles] = useState(() => mergeWithCss(linesHeaderStyles, extendedStyles));
    return (
        <>
            <StyledWrapper {...styles.wrapper} {...{ includeActions }}>
                <StyledWrapper {...styles.itemDescription}>
                    <Typography>{translate(leftTitle || "")}</Typography>
                </StyledWrapper>
                <StyledWrapper {...styles.cases}>{translate(rightTitles?.[0] || "")}</StyledWrapper>
                <StyledWrapper {...styles.priceUnit}>{translate(rightTitles?.[1] || "")}</StyledWrapper>
                <StyledWrapper {...styles.qty}>{translate(rightTitles?.[2] || "")}</StyledWrapper>
                <StyledWrapper {...styles.total} {...{ includeActions }}>{translate(rightTitles?.[3] || "")}</StyledWrapper>
                {!!rightTitles?.[4] && (
                    <StyledWrapper {...styles.actions}>{translate(rightTitles[4] || "")}</StyledWrapper>
                )}
            </StyledWrapper>
            {showMdScreenBorder && <StyledWrapper {...styles.mdScreenBorder}></StyledWrapper>}
        </>
    );
};

LinesHeader.defaultProps = {
    leftTitle: translate("Item Description"),
    rightTitles: ["Cases/Pallet", "Price/Unit", "QTY", "Total"],
};

export default LinesHeader;
